import _ from "lodash";
import TableContainer from "components/TableContainer";
import { getFilterProps, Sorters } from "utils/tableUtils";
import { PermissionSetMap } from "constants/RBACConstants";
import ActionMenuV2 from "components/ActionMenuV2";
import ToolsIntegrationsAPI from "restAPI/ToolsIntegrationAPI";
import message from "components/CustomMessage";
import ModalUtil from "utils/modalUtil";
import ArmisModalForm from "./ArmisModalForm";

const items = [
  { type: "edit", permission: PermissionSetMap.EDIT_TOOL_CONFIG },
  { type: "delete", permission: PermissionSetMap.DELETE_TOOL },
];

const ArmisListing = ({ data, onUpdateConfigComponent, ...props }) => {
  const onDelete = (id) => {
    const { promise } = ToolsIntegrationsAPI.deleteGenericLoginDetail(props.name, id);
    promise.then(() => {
      message.success("Configuration deleted successfully.");
      onUpdateConfigComponent();
    });
    return promise;
  };

  const onClick = async (_, record) => {
    switch (record.name) {
      case "edit":
        ModalUtil.show({
          content: (
            <ArmisModalForm
              configData={record.data}
              onUpdateConfigComponent={onUpdateConfigComponent}
            />
          ),
        });
        break;
      case "delete":
        await onDelete(record.data.id);
        break;
      default:
        break;
    }
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      sorter: Sorters.STRING("name"),
      ...getFilterProps({ dataIndex: "name", dataSource: data }),
    },
    {
      title: "API Endpoint",
      dataIndex: "apiEndpoint",
    },
    {
      title: "Device Types",
      dataIndex: "deviceTypes",
      render: (deviceTypes) => (_.isNull(deviceTypes) || _.isEmpty(deviceTypes) ? "All" : deviceTypes),
    },
    {
      title: "Action",
      key: "action",
      dataIndex: "id",
      width: 50,
      render: (id, obj) => <ActionMenuV2 items={items} onClick={onClick} data={obj} />,
    },
  ];

  return (
    <TableContainer
      loading={_.isUndefined(data)}
      columns={columns}
      dataSource={data}
      title="Configurations"
      defaultSort={{ column: "createdAt", order: "descend" }}
      rowKey="id"
    />
  );
};

export default ArmisListing;
